import { createContext, useContext, useEffect, useState } from "react";
import { createSession } from "../services/api";

export const SessionContext = createContext();

export function SessionContextProvider({ children }) {
  const [session, setSession] = useState(null);

  useEffect(() => {
    console.log("get session");
    createSession().then((r) => {
      localStorage.setItem("guid", r);
      console.log("localStorage", localStorage.getItem("guid"));
      setSession(r);
    });
  }, []);

  const value = { session: session };

  return (
    <SessionContext.Provider value={value}>{children}</SessionContext.Provider>
  );
}

export const useSession = () => {
  return useContext(SessionContext);
};
